/**
 * Product recommendations
 *
 * @module product-recommendations
 * @version 1.0.0
 * @extends HTMLElement
*/

customElements.component = 'product-recommendations';

if(!customElements.get(customElements.component)) {
  class ProductRecommendations extends HTMLElement {

    connectedCallback() {

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then((response) => response.text())
          .then((text) => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length > 0) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('product-card')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .then(() => {

            // Init Slider
            this.initSlider();

          })
          .catch((error) => {
            console.error(error);
          });
      };

      new IntersectionObserver(handleIntersection.bind(this), {
        rootMargin: '0px 0px 200px 0px',
      }).observe(this);
    }

    /**
     * Init slider.
     *
     * @returns {undefined}
    */
    initSlider() {

      this.swiper = this.querySelector('[data-swiper]');
      const swiperMediaPagination = this.querySelector('.swiper-pagination');
      const sectionElement = this.querySelector('[data-related-container]')

      let defaultOptions = {
        preloadImages: true,
        lazy: {
          loadPrevNext: true,
        },
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
        pagination: {
          el: swiperMediaPagination,
          clickable: true
        },
        navigation: {
          nextEl: '.swiper-recommendations-button-next',
          prevEl: '.swiper-recommendations-button-prev',
        }
      }

      let options = (this.dataset.options) ? JSON.parse(this.dataset.options) : {};

      this.options = {...defaultOptions, ...options};

      this.slider = new Swiper(this.swiper, this.options);

      if(sectionElement){
        this.parentElement.classList.remove('hidden')
      }else{
        this.parentElement.classList.add('hidden')
      }
    }
  }

  customElements.define(customElements.component, ProductRecommendations);
}
